export enum LoginType {
  MyFlights = 'MyFlights',
  Booking = 'Booking',
  Anywhere = 'Anywhere'
}

